var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgInbox(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M19.875 14.5312L17.9688 6.78125C17.8438 6.3125 17.4375 6 17 6H7C6.53125 6 6.125 6.3125 6 6.78125L4.09375 14.5312C4.03125 14.8438 4 15.1875 4 15.5V18C4 19.125 4.875 20 6 20H18C19.0938 20 20 19.125 20 18V15.5C20 15.1875 19.9375 14.8438 19.875 14.5312ZM7.375 7.5H16.5938L18.1875 14H15.5C15.1875 14 14.9375 14.1875 14.8125 14.4375L14.0312 16H9.9375L9.15625 14.4375C9.03125 14.1875 8.78125 14 8.5 14H5.78125L7.375 7.5ZM18.5 18C18.5 18.2812 18.25 18.5 18 18.5H6C5.71875 18.5 5.5 18.2812 5.5 18V15.5H8.03125L8.8125 17.0938C8.9375 17.3438 9.1875 17.5 9.5 17.5H14.5C14.7812 17.5 15.0312 17.3438 15.1562 17.0938L15.9375 15.5H18.5V18ZM9.75 10.5H14.25C14.6562 10.5 15 10.1875 15 9.75C15 9.34375 14.6562 9 14.25 9H9.75C9.3125 9 9 9.34375 9 9.75C9 10.1875 9.3125 10.5 9.75 10.5ZM15.25 13C15.6562 13 16 12.6875 16 12.25C16 11.8438 15.6562 11.5 15.25 11.5H8.75C8.3125 11.5 8 11.8438 8 12.25C8 12.6875 8.3125 13 8.75 13H15.25Z",
    fill: "#0D3338"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgInbox);
export default __webpack_public_path__ + "static/media/Inbox.c494064b52caaf7f3dbb742063e230bd.svg";
export { ForwardRef as ReactComponent };